import React, { useEffect, useState } from 'react';

import Axios from 'axios';

import { useCloneModelsAccommodation } from '@hooks/API/Event/UseAccommodation';
import { useCloneModelsFollowup } from '@hooks/API/Event/UseFollowup';
import { useCloneModelsTask } from '@hooks/API/Event/UseTask';
import { useCloneModelsTravel } from '@hooks/API/Event/UseTravel';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import { NwAddButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelsTableColumnNonBookingEvent = ({ model, availability, availabilityInfo }) => {
    const { context } = useContactsSelector();
    const { currentEvent } = context;
    const cs_dispatch = useContactsSelectorDispatch();

    const { mutateAsync: onCloneModelsFollowup } = useCloneModelsFollowup();
    const { mutateAsync: onCloneModelsTravel } = useCloneModelsTravel();
    const { mutateAsync: onCloneModelsToDo } = useCloneModelsTask();
    const { mutateAsync: onCloneModelsAccommodation } = useCloneModelsAccommodation();
    const [addingModel, setAddingModel] = useState(false);

    const tn = currentEvent.TypeName;
    const evid = currentEvent.ID;

    const onAddModelsToEvent = async () => {
        setAddingModel(true);
        const data = {
            EventID: evid,
            ModelIDs: [model.ID],
        };
        try {
            switch (tn) {
                case 'FollowUp':
                    await onCloneModelsFollowup({ data });
                    break;
                case 'Travel':
                    await onCloneModelsTravel({ data });
                    break;
                case 'ToDo':
                    await onCloneModelsToDo({ data });
                    break;
                case 'Accommodation':
                    await onCloneModelsAccommodation({ data });
                    break;
            }
            const eventUpdated = await Axios.get(`/${tn}s/${evid}`);
            eventUpdated.TypeName = tn;
            cs_dispatch({ type: 'UpdateCurrentEvent', eventUpdated: eventUpdated });
            setAddingModel(false);
        } catch (error) {
            console.error('Add Model to EventDates Error => ', error);
            setAddingModel(false);
        }
    };

    return availability ? (
        !availability.inEvent ? (
            <NwAddButton ghost primary label="add model" loading={addingModel} onClick={onAddModelsToEvent} />
        ) : (
            <p>
                <strong>
                    <NwIcon icon={byPrefixAndName.fass['check']} color={StyleVariables.SuccessColor} />
                    &nbsp;added
                </strong>
            </p>
        )
    ) : (
        <p>
            <NwIcon icon={byPrefixAndName.fasl['spinner-third']} spin />
        </p>
    );
};

export default ModelsTableColumnNonBookingEvent;
